import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createContractPriceLists } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractPriceListCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createContractPriceLists,
        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey: queries.contracts.detail._def });
        },
    });
};
